<template lang="pug">
  .body.body-table.technology-table.body-flex
    .table-choose-panel
      .toolbar.toolbar_no-padding.toolbar_margin-bottom
        .toolbar__line
          .parameters
            .semibold Применяемые технологии
          .actions-panel
            e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(
              @click="addNewRowToTable()"
              v-if="!editDisabled"
              label="Добавить"
            )
    e-table-editable(
      ref="detail"
      :attributes="detailAttr"
      :dataUrl="dataUrl"
      :postUrl="postUrl"
      :patchUrl="patchUrl"
      :deleteUrl="deleteUrl"
      :tableInOnlineMode="tableInOnlineMode"
      :afterValidate="afterValidate"
      :afterFetchData="afterFetchData"
      :autoSaveAfterChange='false'
    )
</template>

<script>
import { cadastr, core, tko } from '@/api/api-endpoints'
import { tkoOffline } from '@/api/api-offline-endpoints'
import { PERMS } from '@/config/permissions'
import year from '@/utils/year'

export default {
  name: 'technology-table',
  props: {
    id: null,
    itemId: null,
    tabView: null,
    formDisabled: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      openSelect: false,
      technologies: [],
      actions: [],
      targets: [],
    }
  },
  computed: {
    tableInOnlineMode() {
      return this.itemId
    },
    enabledActions() {
      if (this.formDisabled) {
        return []
      } else {
        return [PERMS.EDIT, PERMS.CREATE, PERMS.DELETE]
      }
    },
    editDisabled() {
      return this.formDisabled
    },
    detailAttr() {
      return {
        name: {
          label: 'Технология',
          validationRulePattern: '(\\.*)',
          placeholder: 'Начните вводить название',
          required: true,
          onChange: this.checkName,
        },
        tko_action: {
          disabled: false,
          required: true,
          width: 200,
          validationRulePattern: '(\\.*)',
          label: 'Вид деятельности',
          placeholder: 'Начните вводить название',
          suggestion: {
            options: this.actions,
            multiple: true,
            onChange: this.onChangeAction,
          },
        },
        tech_target: {
          label: 'Назначение',
          width: 200,
          validationRulePattern: '(\\.*)',
          disabled: false,
          required: true,
          change: this.checkName,
          select: {
            options: this.targets,
          },
        },
        start_year: {
          label: 'Год начала применения',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          disabled: false,
          required: true,
          change: this.checkName,
          select: {
            options: this.operationYear(),
          },
        },
        end_year: {
          label: 'Год окончания применения',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          disabled: false,
          required: true,
          change: this.checkName,
          select: {
            options: this.operationYear(),
          },
        },
      }
    },
    dataUrl() {
      if (this.id) {
        return tko.objectTechOperation(this.id)
      }
      // if new record, offline save
      return tkoOffline.objectTechTable(this.$route.name)
    },
  },
  methods: {
    afterFetchData(ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        const item = data.data[i]
        const actions = JSON.parse(item.tko_actions)
        item.tko_action = actions.map((action) => action.name).join(', ')
      }
      return data
    },
    operationYear() {
      return year.getSpecifiedYearsOptions(1950, 2099)
    },
    afterValidate(ctx, model, errors) {
      if (model.tech_id) {
        let items = ctx.data.data || []
        for (let techIndex = 0; techIndex < items.length; techIndex++) {
          let tech = items[techIndex]
          let techRowId = tech.id || tech._storeUUID
          let modelId = model.id || model._storeUUID
          if (techRowId != modelId && model.tech_id == tech.tech_id) {
            errors.name = 'Данная технология уже была добавлена'
            // TODO: fix bug in table editable component
            ctx.openEditMode(model)
            setTimeout(() => {
              ctx.openEditMode(model)
            }, 0)
          }
        }
      }
      return errors
    },
    suggestionEndpoint(ctx, q) {
      return cadastr.techs({ query: { q: q, 'per-page': 50 } })
    },
    getTkoAction(ctx, q) {
      return core.collection('tko_action', { query: { type: q } })
    },
    getTechAction(ctx, q) {
      return core.collection('tech_target', { query: { type: q } })
    },
    transformSuggestions(ctx, response) {
      return response.data
    },
    postUrl() {
      return tko.objectTechOperationPost(this.id)
    },
    patchUrl(context, model) {
      return tko.objectTechOperationPatch(model.id)
    },
    deleteUrl(context, model) {
      return tko.objectTechOperationDelete(model.id)
    },
    addNewRowToTable() {
      const Model = () => {
        return {
          id: '',
          name: '',
          techTargetName: '',
        }
      }
      this.$refs.detail.createRow(new Model())
    },
    async getCollections() {
      const collections = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: core.collection('tko_action', {
            query: { 'per-page': -1 },
          }),
        })
      ).data
      this.actions = collections.tko_action
      this.actions = this.actions.map((item) => {
        return {
          id: item.name,
          name: item.name,
          value: item.id,
        }
      })
      this.targets = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: core.collection('tech_target', {
            query: { 'per-page': -1 },
          }),
        })
      ).data.tech_target
      this.targets = this.targets.map((item) => {
        return {
          id: item.name,
          name: item.name,
          value: item.id,
        }
      })
    },
    onChangeAction(ctx, $event, model) {
      this.checkName(this, null, model)
    },
    async checkName(ctx, $event, model) {
      if (
        model.tko_action &&
        model.tech_target &&
        model.start_year &&
        model.end_year
      ) {
        const tech_target_id = this.targets.find(
          (item) => item.id === model.tech_target
        )?.value

        const tko_action_id = this.actions.find(
          (item) => item.id === model.tko_action
        )?.value

        let id = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: cadastr.techs({
              query: { q: model.name, 'per-page': 50 },
            }),
          })
        ).data.data[0]?.id
        if (!id) {
          id = await (
            await this.$store.dispatch('createModel', {
              url: cadastr.techs(this.$route),
              data: {
                ...model,
                tech_target_id,
                tko_action_id,
                has_expertise: false,
                has_project: false,
                actions: false,
              },
            })
          ).data.id
        }

        model.tech_id = id
        model.tko_action_id = tko_action_id
        model.tko_actions = JSON.stringify(
          model.tko_action.map((item) => {
            const action = this.actions.find((action) => action.name === item)
            return { id: action.value, name: action.name }
          })
        )
        model.tko_action_ids = model.tko_action.map((item) => {
          const action = this.actions.find((action) => action.name === item)
          return action.value
        })
      }
    },
  },
  created() {
    this.getCollections()
  },
}
</script>

<style lang="scss">
.technology-table .customSelect__tags-area {
  border: none;
}
</style>
